
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type SearchBoxHeroRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function SearchBoxHeroRT(): TemplateResult<SearchBoxHeroRTRootProps> {
    return _createElement('form', {
        'className': 'cm-search-box-hero',
        'onSubmit': this.preventFormSubmission
    }, _createElement('div', { 'className': 'cm_search-box_form-container' }, [
        [this.searchInput(function () {
                return _createElement('div', { 'className': 'cm_searchInput' }, _translate(`search_box_hero_placeholder`));
            }, {
                widgetName: 'undefined',
                items: undefined
            })],
        _createElement('div', {
            'className': 'cm_search-box_submit cm_button cm_button__primary',
            'title': 'Search',
            'aria-label': 'search button',
            'data-cm-role': 'add-query',
            'key': '1242'
        }, '\n  ', _translate(`search_box_hero_submit`), '\n')
    ]));
}
        export const componentNames = ["cm:searchInput"]